<template>
  <div class="bigbox">
    <div
      class="bg_img"
      :style="{
        backgroundImage: `url(${puzzleDetail.background_img})`,
        backgroundColor: `${puzzleDetail.background_color}`
      }"
    ></div>
    <div class="puzzlebox" ref="barVal">
      <div v-if="hasInner">
        <div class="tishi">
          <div class="left">
            <div class="rank" @click="upStatus(true)">
              <img class="jiang" src="@/assets/img/rank.svg" />
              <div>Rank List</div>
            </div>
          </div>
          <div class="right">
            <div class="nowtime">Time: {{ str }}</div>
            <div class="besttime">Your best time: {{ besttime }}</div>
          </div>
        </div>
        <div class="game" v-if="isStart">
          <puzzle
            ref="dpuzzle"
            @getStatus="getStatus"
            @next="handleNext"
            v-bind="puzzleConfig[level]"
            v-bind:beishu="beishu"
            v-on:statusChanged="upFormStatus($event)"
          />
        </div>
        <div class="init" v-if="!isStart">
          <img :src="puzzleConfig[0].img" />
        </div>
        <div class="buttons">
          <div class="start" @click="start" v-show="!isAgain">Start</div>
          <div class="start" @click="start" v-show="isAgain">Again</div>
          <div class="change" @click="changePic">
            <img src="@/assets/img/try.svg" />
            Try another picture
          </div>
        </div>
        <div class="adver">
          <img :src="puzzleDetail.brief_img" />
        </div>
        <div class="rules">
          <div class="rules-title">Rules:</div>
          <div
            class="rules-content"
            v-for="(rule, index) in rules"
            :key="index"
          >
            <div class="rules-detail" v-html="rule"></div>
          </div>
        </div>
        <Rank
          ref="rankChild"
          v-if="showRank"
          v-on:statusChanged="upStatus($event)"
        />
        <Form
          ref="formChild"
          v-if="showForm"
          :hasPrize="hasPrize"
          :rankIndex="rankIndex"
          :time="str"
          :submitTime="submittime"
          :showForm="showForm"
          @changeShowForm="showformFun"
          @start="start"
        />
      </div>
    </div>
  </div>
</template>
<script>
import puzzle from "@/components/Puzzle";
import Rank from "@/components/rank.vue";
import Form from "@/components/form.vue";
import {
  getMyRank,
  submitAddTime,
  getPuzzleConfigure,
  getCurrentRank
} from "@/util/data.js";
import { showToast } from "@/util/utils.js";
export default {
  components: {
    puzzle,
    Rank,
    Form
  },
  data() {
    return {
      level: 0,
      puzzleConfig: [{ img: "", row: 3, col: 3 }],
      images: [], //拼图图片
      status: "进行中......",
      isStart: false, //游戏是否开始
      isActivityFlag: true, //后台编辑游戏是否可玩
      hour: 0, //定义时，分，秒，毫秒并初始化为0；
      minute: 0,
      second: 0, //秒
      ms: 0, //毫秒
      time: "",
      besttime: "00:00.00",
      str: "00:00.00",
      isClick: true, //是否可点击（每次开始时间间隔6.5秒）

      beishu: 0.75,

      showRank: false,
      showForm: false, // 20211203
      isAgain: false,
      puzzleDetail: {}, //拼图活动配置信息
      rules: [],
      submittime: null, //要提交到接口的时间
      hasInner: false,
      rankIndex: "", //当前成绩排名
      imgIndex: 0,
      hasPrize: true //是否有奖品
    };
  },
  created() {
    this.puzzleConfigure();
    let token = this.$store.state.token || window.localStorage.getItem("token");
    if (token) {
      this.getMyrank();
    }
  },
  mounted() {
    const that = this;
    var valWidth = that.$refs.barVal.clientWidth;
    var beishu = valWidth / 800;
    that.beishu = beishu;
    window.onresize = () => {
      var valWidth = that.$refs.barVal.clientWidth;
      window.screenWidth = document.body.clientWidth;
      that.screenWidth = window.screenWidth;
      if (that.screenWidth <= 768) {
        valWidth = that.screenWidth - 30;
      }
      var beishu = valWidth / 800;
      that.beishu = beishu;
    };
  },
  computed: {
    token: function() {
      return this.$store.state.token || window.localStorage.getItem("token");
    }
  },
  watch: {
    token() {
      let token =
        this.$store.state.token || window.localStorage.getItem("token");
      if (token) {
        this.getMyrank();
      }
    }
  },
  methods: {
    puzzleConfigure() {
      getPuzzleConfigure({ id: this.$route.params.id })
        .then(res => {
          if (res.code === 1) {
            if (res.data == null || res.data.template_id != 1) {
              // 该活动不存在
              this.hasInner = false;
              return;
            }
            this.hasInner = true;
            this.puzzleDetail = res.data;
            this.rules = res.data.rules.split("\n");
            this.images = JSON.parse(res.data.images);
            this.changePic();

            res.data.start_time = res.data.start_time.replace(/-/g, "/");
            res.data.end_time = res.data.end_time.replace(/-/g, "/");
            var start = new Date(res.data.start_time).getTime();
            var end = new Date(res.data.end_time).getTime();
            var now = Date.parse(new Date());
            if (now >= start && now <= end) {
              this.isActivityFlag = true;
            } else if (now < start) {
              this.isActivityFlag = 0;
            } else this.isActivityFlag = -1;
          } else {
            var msg = res.message || res.msg || "Fail!";
            showToast(this, msg);
          }
        })
        .catch(err => {
          showToast(this, "Fail!");
        });
    },
    changePic() {
      var len = this.images.length;
      var num = Math.floor(Math.random() * len);
      if (this.imgIndex == num) {
        this.changePic();
      } else {
        this.imgIndex = num; //如取[0,10]的随机整数：Math.floor(Math.random()*11)
        this.puzzleConfig[0].img = this.images[this.imgIndex];
        this.isStart = false;
        this.reset();
      }
    },
    handleNext() {
      this.status = this.$refs.dpuzzle.status;
      this.level++;
      if (this.level == this.puzzleConfig.length - 1) {
        const answerFlag = window.confirm("已经是最后一关了，需要重新开始么？");
        if (answerFlag) {
          this.level = 0;
        }
      }
    },
    getStatus() {
      this.status = this.$refs.dpuzzle.status;
    },
    start() {
      if (!this.isActivityFlag) {
        showToast(this, "The game hasn't started yet.");
        return;
      } else if (this.isActivityFlag === -1) {
        showToast(this, "The game is already over.");
        return;
      }
      let token =
        this.$store.state.token || window.localStorage.getItem("token");
      if (this.puzzleDetail.is_validate_login == 1 && !token) {
        //后台若选择登录验证，则需登录才可以玩游戏
        this.$store.commit("updateLoginState", true);
        return;
      } else if (!this.isStart) {
        if (this.isClick) {
          this.isClick = false;
          setTimeout(() => {
            this.isClick = true;
          }, 6500);
          this.isStart = true;
          this.reset();
          this.timeStart();
          this.$nextTick(() => {
            this.$refs.dpuzzle.zhikong(); //第九个格子透明度降为0
          });
        } else if (!this.isClick) {
          showToast(this, "You clicked too often, please try later.");
        }
      }
    },
    timeStart() {
      this.time = setInterval(this.timer, 10);
    },
    timer() {
      //定义计时函数
      this.ms = this.ms + 10; //毫秒
      if (this.ms >= 1000) {
        this.ms = 0;
        this.second = this.second + 1; //秒
      }
      if (this.second >= 60) {
        this.second = 0;
        this.minute = this.minute + 1; //分钟
      }
      if (this.minute >= 60) {
        this.minute = 0;
        this.hour = this.hour + 1; //小时
        this.stop(); //超时暂停时间
      }
      this.str =
        this.toDub(this.minute) +
        ":" +
        this.toDub(this.second) +
        "." +
        this.toDubms(this.ms);
      if (this.minute == 59 && this.second == 59) {
        this.stop();
      }
    },
    toDub(n) {
      //补0操作
      if (n < 10) {
        return "0" + n;
      } else {
        return "" + n;
      }
    },
    toDubms(num) {
      var data = num / 10;
      return data;
    },
    stop() {
      clearInterval(this.time);
    },
    reset() {
      //重置
      clearInterval(this.time);
      this.hour = 0;
      this.minute = 0;
      this.ms = 0;
      this.second = 0;
      this.str = "00:00:00";
    },
    showformFun(val) {
      this.showForm = false;
    },
    upStatus(status) {
      this.showRank = status;
      if (status) {
        this.$store.commit("updateRoleState", true);
      } else {
        this.$store.commit("updateRoleState", false);
      }
    },
    upFormStatus(status) {
      if (status) {
        //游戏成功
        this.stop(); //时间暂停
        this.isAgain = true;
        this.isStart = false;
        this.successFun();
      }
    },
    successFun() {
      var time = this.minute * 60 + this.second;
      time = time + "." + this.ms;
      time = parseFloat(time);
      this.submittime = time;

      let token =
        this.$store.state.token || window.localStorage.getItem("token");
      getCurrentRank(
        {
          cost_time: time,
          activity_id: this.$route.params.id
        },
        token
      )
        .then(res => {
          if (res.code === 1) {
            this.rankIndex = res.data.rank;
            this.showForm = true;
            this.getMyrank();
            this.$refs.rankChild.getRanks(); //游戏成功，提交成功，刷新排行榜
            this.$refs.formChild.getMyrank(); //游戏成功，提交成功，刷新个人排名
          } else {
            var msg = res.message || res.msg || "Fail!";
            showToast(this, msg);
          }
        })
        .catch(err => {
          //showToast(this, "Fail!");
        });
    },
    getMyrank() {
      let token =
        this.$store.state.token || window.localStorage.getItem("token");
      if (token) {
        getMyRank(
          {
            activity_id: this.$route.params.id
          },
          token
        )
          .then(res => {
            if (res.code === 1) {
              if (res.data.score != -1) {
                this.dealTime(res.data.score);
              }
            } else {
              var msg = res.message || res.msg || "Fail!";
              showToast(this, msg);
            }
          })
          .catch(err => {
            //showToast(this, "Fail!");
          });
      }
    },
    dealTime(data) {
      var time = data + "";
      var timeArr = time.split(".");
      var num = parseFloat(timeArr[0]);
      var str = "";
      var str1 = "";
      var str2 = "";
      var str3 = "";
      if (num > 60) {
        if (Math.floor(num / 60) < 10) {
          str1 = "0" + Math.floor(num / 60);
        }
        if (Math.floor(num / 60) >= 10) {
          str1 = Math.floor(num / 60);
        }
        if (num % 60 < 10) {
          str2 = "0" + (num % 60);
        }
        if (num % 60 >= 10) {
          str2 = num % 60;
        }
        str = str1 + ":" + str2;
      } else {
        if (num < 10) {
          str2 = "0" + timeArr[0];
        }
        if (num >= 10) {
          str2 = timeArr[0];
        }
        str = "00:" + str2;
      }
      if (timeArr[1]) {
        // 先判断字符串的个数
        if (timeArr[1].length == 1) {
          str = str + "." + timeArr[1] + "0";
        } else if (timeArr[1].length == 2) {
          str = str + "." + timeArr[1];
        }
      } else {
        str = str + ".00";
      }
      this.besttime = str;
    }
  }
};
</script>
<style scoped>
.bigbox {
  background: rgba(0, 0, 0, 0.6);
}
.puzzlebox {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 30px 0;
}
.bg_img {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -10;
  zoom: 1;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
}
.puzzlebox .game {
  height: 0;
  width: 100%;
  padding-bottom: 100%;
}
.init,
.init img {
  width: 100%;
  height: 100%;
  display: block;
}
.adver,
.adver img {
  width: 100%;
}
.tishi {
  overflow: hidden;
  margin-bottom: 30px;
}
.tishi .left {
  font-weight: 700;
  color: #ffc84d;
  float: left;
  margin-top: 14px;
}
.tishi .left .rank {
  overflow: hidden;
  cursor: pointer;
}
.tishi .left .rank img {
  float: left;
  width: 30px;
  margin-right: 15px;
}
.tishi .left .rank div {
  float: left;
  font-size: 20px;
  margin-top: 6px;
}
.tishi .right {
  float: right;
}
.tishi .right .nowtime {
  font-size: 21px;
  font-weight: 700;
  color: #ffc84d;
  text-align: left;
  /* width:160px; */
  margin-bottom: 15px;
  white-space: nowrap;
}
.tishi .right .besttime {
  opacity: 0.7;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  text-align: right;
}
.buttons {
  overflow: hidden;
}
.buttons .start {
  width: 213px;
  height: 43px;
  border: 1px solid #ffd86f;
  border-radius: 5px;
  cursor: pointer;
  font-size: 20px;
  color: white;
  text-align: center;
  line-height: 43px;
  margin: 32px auto 23px auto;
}
.buttons .change {
  cursor: pointer;
  color: white;
  opacity: 0.7;
  text-align: center;
  margin-bottom: 35px;
  padding: 11px 0;
  margin-top: -10px;
}
.buttons .change:hover img {
  transform: rotate(180deg);
  transition-duration: 0.5s;
}
.buttons .change img {
  width: 14px;
  height: 13px;
  margin-top: 1px;
  margin-right: 5px;
}
.rules {
  margin: 30px 0;
  line-height: 20px;
}
.rules .rules-title {
  font-weight: 700;
  color: #ffc84d;
  font-size: 22px;
  margin-bottom: 12px;
}
.rules-content {
  color: white;
  opacity: 0.7;
  font-size: 14px;
}
@media screen and (max-width: 768px) {
  .puzzlebox {
    width: calc(100% - 30px);
    margin: 0 auto;
    max-width: initial;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Puzzle.vue